import React from "react";
import Link from "next/link";

import { Action, Category } from "constants/events";
import { useEventTracker } from "hooks/useEventTracker";
import isMobileDevice from "utils/isMobileDevice";

const UnverifiedListing: React.FC<{
  dispensaryId: number;
}> = ({ dispensaryId }) => {
  const { publishEvent } = useEventTracker();
  const isMobile = isMobileDevice();

  return (
    <>
      {isMobile ? (
        <div className="font-bold text-xs" data-testid="claim-dispensary">
          <Link
            href="https://success.leafly.com/claim-your-store"
            className="underline text-green"
            onClick={() =>
              publishEvent({
                action: Action.click,
                category: Category.dispensaryMenu,
                dispensaryId,
                label: "info tier dispensary - upgrade now",
              })
            }
          >
            unverified business
          </Link>
        </div>
      ) : (
        <div
          className="p-lg border border-light-grey rounded"
          data-testid="claim-dispensary"
        >
          <p className="font-bold text-sm mb-xs">Unverified listing</p>
          <p className="font-bold text-xs">Is this your business?</p>
          <p className="text-xs pr-4">
            Level up to post deals, update your store info, upload your menu,
            respond to reviews, and much more!
          </p>
          <Link
            href="https://success.leafly.com/claim-your-store"
            className="underline text-charcoal text-xs"
            onClick={() =>
              publishEvent({
                action: Action.click,
                category: Category.dispensaryMenu,
                dispensaryId,
                label: "info tier dispensary - upgrade now",
              })
            }
          >
            claim now
          </Link>
        </div>
      )}
    </>
  );
};

export default UnverifiedListing;
